<script>
    import { mapState } from 'vuex';

    export default {
        name: "session-logout-timer",

        computed: {
            ...mapState('sessionTimeout', [
                'formattedLogoutTime',
                'logoutTimerVisible',
            ]),
        }
    }
</script>

<template>
    <div v-if="logoutTimerVisible" class="session-logout-timer">
        <h3 class="session-logout-timer__time">{{ formattedLogoutTime }}</h3>
        <span class="session-logout-timer__text">
            Left until you<br />
            are logged out
        </span>
    </div>
</template>